import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [company, setCompany] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setCompany(data.company);
      return data;
    } catch (e) {
      setUser(false);
      setCompany(null);
      return null;
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const applySession = (data) => {
    setUser(data.user);
    setCompany(data.company);
  };

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
    setCompany(null);
  };

  return (
    <AuthCtx.Provider value={{ user, company, refresh, applySession, logout }}>{children}</AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
